module.exports = __webpack_public_path__ + "static/img/b6.0a4e573.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/b6.jpg
// module id = DvzD
// module chunks = 0